export default "__VITE_ASSET__Pry9hMXt__"